import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { ClientFilter } from '../../models/clientFilter.model';
import { HttpParams } from '@angular/common/http';
import { Client } from '../../models/client.model';

@Injectable({ providedIn: 'root' })
export class ClientService {
    constructor(private dataService: DataService) {}

    public get(page: number, filter: ClientFilter) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.corporateName', filter.corporateName || '')
            .set('filter.entity.cnpj', filter.cnpj || '');


        return this.dataService.get<Result<any>>("client", params);
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<string>>('client/' + cod.toString());
    }

    public save(client: Client) {
        return this.dataService.put<Result<Client>>('client', client);
    }
}
